import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const useWhatsAppLead = () => {
  const { user } = useAuth();
  const [form, setForm] = useState({ name: "", phone: "", message: "" });
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [saved, setSaved] = useState(null);
  const [error, setError] = useState("");
  const id = useRef(crypto.randomUUID());
  const sending = useRef(false);
  useEffect(() => {
    if (user) setForm((old) => ({ ...old, name: old.name || user.name, phone: old.phone || user.phone || "" }));
  }, [user]);
  const set = (key) => (event) => setForm((old) => ({ ...old, [key]: event.target.value }));
  const startNew = () => { id.current = crypto.randomUUID(); setSaved(null); setError(""); setConsent(false); };

  const submit = async (event) => {
    event.preventDefault();
    if (sending.current || !consent) return;
    sending.current = true;
    setBusy(true);
    setError("");
    // Open only a blank, detached window during the user gesture so mobile popup
    // blockers don't swallow the later async navigation. Close it on save failure.
    let popup = null;
    try {
      popup = window.open("about:blank", "_blank");
      if (popup) { popup.opener = null; popup.document.title = "Saving your enquiry"; popup.document.body.textContent = "Saving your enquiry…"; }
    } catch { popup = null; }
    try {
      const { data } = await axios.post(`${API}/contact/whatsapp`, { ...form, consent: true, request_id: id.current });
      const destination = new URL(data.whatsapp_url);
      if (destination.protocol !== "https:" || destination.hostname !== "wa.me" || destination.username) throw new Error("Invalid WhatsApp destination");
      setSaved(data);
      if (popup && !popup.closed) {
        try { popup.location.replace(data.whatsapp_url); } catch { popup.close(); }
      }
    } catch (err) {
      if (popup && !popup.closed) popup.close();
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : Array.isArray(detail) ? "Please check your name, phone number and message." : "Your enquiry could not be saved. Please retry or use direct WhatsApp chat.");
    } finally {
      sending.current = false;
      setBusy(false);
    }
  };
  return { form, set, consent, setConsent, busy, saved, error, submit, startNew };
};